export default {
  directives: {
    preventAndroidScroll: {
      bind: function bind(el) {
        import('@tencent/vft-common/tenvideo').then(function (_ref) {
          var tenvideo = _ref.default;
          if (tenvideo.isTenvideo() && navigator.userAgent.indexOf('Android') >= 0) {
            tenvideo.tenvideoReady(function () {
              var startX;
              var startY;
              var hasIntercepted = false;
              $(el).off('touchstart').on('touchstart', function (e) {
                try {
                  TenvideoJSBridge.invoke('requestSlideIntercept', {
                    request: true
                  });
                } catch (err) {}
                startX = e.touches[0].pageX;
                startY = e.touches[0].pageY;
                hasIntercepted = false;
              }).off('touchmove').on('touchmove', function (e) {
                var touch;
                var slope;
                if (hasIntercepted) {
                  return;
                }
                touch = e.touches[0];
                slope = Math.abs((touch.pageY - startY) / (touch.pageX - startX));
                if (slope < 1) {
                  try {
                    TenvideoJSBridge.invoke('requestSlideIntercept', {
                      request: true
                    });
                    hasIntercepted = true;
                  } catch (err) {}
                } else {
                  try {
                    TenvideoJSBridge.invoke('requestSlideIntercept', {
                      request: false
                    });
                    hasIntercepted = true;
                  } catch (err) {}
                }
              }).off('touchend').on('touchend', function () {
                try {
                  TenvideoJSBridge.invoke('requestSlideIntercept', {
                    request: false
                  });
                  hasIntercepted = false;
                } catch (err) {}
              });
            });
          }
        });
      },
      unbind: function unbind(el) {
        $(el).off('touchstart').off('touchmove').off('touchend');
      }
    }
  }
};